import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux'
import { getSuperadminData } from '../../slices/superadmin'
import PivotTableUI from 'react-pivottable/PivotTableUI';
import TableRenderers from 'react-pivottable/TableRenderers';
import createPlotlyComponent from 'react-plotly.js/factory';
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';
import DatePicker from 'react-datepicker';

const SuperAdmin = () => {

    const addMonths = (input, months) => {
        const date = new Date(input.getFullYear(), input.getMonth(), 1)
        date.setMonth(date.getMonth() + months)
        return date
    }

    const formatDate = (date) => {
        return ('0' + date.getDate()).slice(-2) + "/" + ('0' + (date.getMonth()+1)).slice(-2) + "/" + date.getFullYear();
    }

    const dispatch = useDispatch()
    const Plot = createPlotlyComponent(window.Plotly);
    const PlotlyRenderers = createPlotlyRenderers(Plot);
    const renderers = Object.assign({}, TableRenderers, PlotlyRenderers)
    const superadmin = useSelector((state) => state.superadmin)
    const [dataset, setDataset] = useState([])
    const [startDate, setStartDate] = useState(addMonths(new Date(), -6));
    const [endDate, setEndDate] = useState(new Date());
    const [fetchNewData, setFetchNewData] = useState(false);
    const user = useSelector((state) => state.auth.user)

    const onChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
        if(start && end){
            setFetchNewData(true);
        }
    };

    useEffect(() => {
        dispatch(getSuperadminData({startDate: formatDate(startDate), endDate: formatDate(endDate)}))
    }, [])

    useEffect(() => {
        if (fetchNewData) {
            dispatch(getSuperadminData({startDate: formatDate(startDate), endDate: formatDate(endDate)}))
            setFetchNewData(false);
        }
    }, [fetchNewData])

    useEffect(() => {
        if (!superadmin.loading && superadmin.data.length > 0) {
            let data = JSON.parse(JSON.stringify(superadmin.data));
            setDataset(data)
        }
    }, [superadmin])

    const [currentProps, setCurrentProps] = useState({
        group: 'Accounts',
        rendererName: 'Table',
        cols: ['Year/Month'],
        rows: ['account', 'currency'],
        vals: ['total', 'total'],
        aggregatorName: 'Sum',
    })

    var monthYearDeriver = function() {
        return function(record) {
            const date = new Date(record.month);
            if (isNaN(date)) {
                return '';
            }
            return date.getFullYear() + "/" + (date.getMonth()+1);
        }
    }

    const sorters = {
        "Year/Month": function(a, b) {
            let partsa = a.split("/");
            let yeara = parseInt(partsa[0]);
            let montha = parseInt(partsa[1]);
            let partsb = b.split("/");
            let yearb = parseInt(partsb[0]);
            let monthb = parseInt(partsb[1]);
            if (yearb < yeara || yearb > yeara ){
                return yearb-yeara
            } else {
                return monthb-montha
            }
        }
    }

    return (
        user && 
        ( user.is_superuser ?
            <div className="container-fluid superadmin">
                <div className="row align-items-center">
                    <div className="col mb-3">
                        <h1 className="title">Super Admin</h1>
                    </div>
                    <div className="col mb-3 text-end">
                        <div className="d-inline-block">
                        <DatePicker
                            selected={startDate}
                            onChange={onChange}
                            startDate={startDate}
                            endDate={endDate}
                            minDate={new Date(2019, 4, 1)}
                            selectsRange
                            dateFormat="dd-MM-yyyy"
                            showMonthYearPicker
                        />
                        </div>
                    </div>
                </div>
                {dataset.length > 0 &&
                    <div className="row superadmin-table-container">
                        <div className="col">
                            <PivotTableUI
                                data={dataset}
                                onChange={setCurrentProps}
                                {...currentProps}
                                sorters={sorters}
                                renderers={renderers}
                                derivedAttributes={{
                                    "Year/Month": monthYearDeriver()
                                }}
                            />
                        </div>
                    </div>
                }
            </div>
            :
            <div className="container-fluid superadmin">
                <div className="row align-items-center">
                    <div className="col mb-3">
                        <h1 className="title">Unauthorized</h1>
                    </div>
                </div>
                <div className="row superadmin-table-container">
                    <div className="col">
                        <p>You are not authorized to view this page.</p>
                    </div>
                </div>
            </div>
        )
    )
}

export default SuperAdmin